import { z } from 'zod';

export const contactTypes = ['SUPORTE', 'BUG', 'SUGESTAO', 'OUTRO'] as const;

export const contactSubmissionSchema = z.object({
  name: z.string().trim().min(2, 'Informe seu nome.').max(100),
  email: z.string().trim().email('Informe um e-mail válido.').max(254),
  subject: z.string().trim().min(3, 'Informe um assunto.').max(160),
  message: z.string().trim().min(10, 'Conte um pouco mais sobre o contato.').max(5000),
  type: z.enum(contactTypes, {
    errorMap: () => ({ message: 'Selecione um tipo válido.' }),
  }),
  website: z.string().max(0).optional(),
});

export type ContactSubmissionInput = z.infer<typeof contactSubmissionSchema>;
